// extracted by mini-css-extract-plugin
module.exports = {"titleWrapper":"style_titleWrapper__2WEE4","rowsWrapper":"style_rowsWrapper__3gKW7","rowWrapper":"style_rowWrapper__2711e"};